<template>
    <div class="split-content" v-bind:class="{ hasText: text }">
      <span>
        {{ text }}
      </span>
    </div>
</template>

<script>
    export default {
        name: "SplitContent",
        props: ['text']
    }
</script>

<style scoped>
    .split-content {
        display: block;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        font-size: 1.15em;
        font-weight: 500;
    }

    .split-content > span {
        position: relative;
        display: inline-block;
    }

    .split-content > span:before,
    .split-content > span:after {
        content: "";
        position: absolute;
        top: 50%;
        width: 9999px;
        height: 1px;
        background: #979797;
    }

    .split-content > span:before {
        right: 100%;
    }

    .split-content > span:after {
        left: 100%;
    }

    .split-content.hasText > span:before {
        margin-right: 15px;
    }

    .split-content.hasText > span:after {
        margin-left: 15px;
    }

</style>